import React, { ReactNode, useEffect, useRef } from 'react';
import { useNotification } from 'hooks/use-notification';
import { useAuthStore } from './store/auth/useAuthStore';
// import { useNotificationStore } from './store/common/useNotificationStore';

export const NotificationMiddleware: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const wasConnectedRef = useRef<boolean>(false);

  const { connect, disconnect } = useNotification();

  useEffect(() => {
    if (!isAuthenticated) {
      wasConnectedRef.current = false;
      disconnect.current?.();
      return;
    }
    if (!wasConnectedRef.current) {
      wasConnectedRef.current = true;
      connect();
    }
    return () => {
      disconnect.current?.();
    };
  }, [isAuthenticated]);

  return <>{children}</>;
};
